// Thin wrapper around window.Telegram.WebApp (injected by https://telegram.org/js/telegram-web-app.js, loaded in
// index.html). Docs: ai/references/https/core.telegram.org/bots/webapps/_.md in the repo root.
// Every accessor tolerates the SDK being absent (plain browser) by doing nothing, so callers need no guards.

interface TelegramWebApp {
  initData: string
  initDataUnsafe?: { start_param?: string }
  ready(): void
  expand(): void
}

function getWebApp(): TelegramWebApp | undefined {
  return (window as unknown as { Telegram?: { WebApp?: TelegramWebApp } }).Telegram?.WebApp
}

// The SDK script is also present in a normal browser, there `initData` is an empty string.
export function isInsideTelegram(): boolean {
  return !!getWebApp()?.initData
}

export function getInitData(): string {
  return getWebApp()?.initData ?? ''
}

export function getStartParam(): string | null {
  return getWebApp()?.initDataUnsafe?.start_param ?? null
}

export function ready(): void {
  getWebApp()?.ready()
}

export function expand(): void {
  getWebApp()?.expand()
}

// A Mini App link `https://t.me/<bot>/<app>?startapp=<param>` hands <param> to the app (A-Z a-z 0-9 _ - only).
// `c_<uuid>` opens a control link (like `/?link=<uuid>`), `s_<uuid>` a session permalink; anything else: nowhere.
const UUID = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}'

export function startParamToRoute(param: string | null | undefined): string | null {
  if (!param) return null
  const control = new RegExp(`^c_(${UUID})$`).exec(param)
  if (control) return `/?link=${control[1]}`
  const session = new RegExp(`^s_(${UUID})$`).exec(param)
  if (session) return `/session/${session[1]}`
  return null
}
